import thunk from "redux-thunk";
import rootReducer from "./reducers";
import storage from "redux-persist/lib/storage";
import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import { composeWithDevTools } from "redux-devtools-extension";

const middleware = [thunk];

const persistConfig = {
  key: "appReducer",
  storage: storage,
  whitelist: [
    "auth",
    "store",
    "group",
    "loyalty",
    "campsRoot",
    "campsUnPersRoot",
    "autoCamps",
    "productTour",
  ],
};

const bindMiddleware = () => {
  if (import.meta.env.MODE !== "production") {
    return composeWithDevTools(applyMiddleware(...middleware));
  }
  return applyMiddleware(...middleware);
};

const presistedReducer = persistReducer(persistConfig, rootReducer);
const store = createStore(presistedReducer, bindMiddleware());

export const persistor = persistStore(store);
export default store;
